import React from "react";
import { ShieldCheck } from "lucide-react";
import { braveryBoost } from "../mock";
import Reveal from "./Reveal";

const BraveryBoost = () => {
  return (
    <section className="bg-white pt-8 md:pt-10 pb-16 md:pb-20">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <Reveal>
          <div
            className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6"
            style={{ backgroundColor: "rgba(241,201,31,0.18)" }}
          >
            <ShieldCheck className="w-9 h-9" style={{ color: "#FF6C10" }} />
          </div>
          <h2 className="font-display text-3xl md:text-5xl" style={{ color: "#187EE4" }}>
            {braveryBoost.title}
          </h2>
          <p className="mt-5 text-lg md:text-xl text-slate-600 leading-relaxed font-medium">
            {braveryBoost.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default BraveryBoost;
